module.exports = __webpack_public_path__ + "img/dt-logo-vertical-white-text.fe7a49e8.svg";